import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import ContainerLoader from "../../UI/ContainerLoader";
import {CleanUrl} from "../../../utils/cleanUrl";


export default function PepsiEaConnection(props) {
	const {promotionSettings, userResponse, onNextStep} = props;
	const {t} = useTranslation();
	const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);
	const [submitInProgress, setSubmitInProgress] = useState(false);
	const [showDoNotConnectBtn, setShowDoNotConnectBtn] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	let fetchURL = "";
	const eaConnectUrl = window.home + 'eaconnect';
	// const EAConnectionRequired = window.connectionRequired;




	if (window.pathPrefix !== "") {
		fetchURL = `${process.env.REACT_APP_BASE_URL}/${window.pathPrefix}/api/v1/pepsico_joy_eu_ea/never-connect`;
	} else {
		fetchURL = `${process.env.REACT_APP_BASE_URL}/api/v1/pepsico_joy_eu_ea/never-connect`;
	}

	useEffect(() => {
		if (promotionSettings.promotion_type.ea_settings.weekly_draw) {
			setShowDoNotConnectBtn(true);
		}
	}, []);

	function handleNextStep() {
		onNextStep();
	}


	const handleDoNotConnect = async () => {
		setSubmitInProgress(true);
		const csrfToken = window.promotionCsrfToken;

		fetch(fetchURL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-Token': csrfToken,
			},

		}).then(response => {
			if (!response.ok) {
				if (response.status >= 500) {
					throw new Error('Server error');
				} else {
					return response.json().then(errorData => {
						throw errorData;
					});
				}
			}
			return response.json();

		}).then(data => {
			// If the user selects do not connect me, continue to the next step.
			if (data.new_status === -1) {
				onNextStep();
			}
		}).catch(error => {
			console.log("error >> ", error);
			if (error.message) {
				setErrorMsg(error.message);
			}
		}).finally(function () {
			setSubmitInProgress(false);
		});
	};


	return (
		<div className="form-style-container">
			<div className="promo-step-section">
				<div className="promo-fields-group promo-fields__border-bottom">
					{submitInProgress && <ContainerLoader/>}
					<div className="promo-fields">
						<div className="promo-field">
							<div className="promo-fields-header">
								<h3 className="heading5 promo-fields-title">{t("Connect your EA Account")}</h3>
								<div className={"info-text"}>
									{t("To receive free EA SPORTS FC™ 25 in-game rewards you need to connect your Pepsi Promo Account with your EA Account")}
								</div>
							</div>
						</div>
						<div className="promo-field">
							<div className="promo-fields-action">
								<a href={eaConnectUrl}
								   className="btn btn-primary">{t("Connect now")} </a>
								{showDoNotConnectBtn && <>
									<button type="button" className="btn btn-primary link"
											onClick={handleDoNotConnect}>
										<span className="in-btn-text">
											{t("DON’T CONNECT")}
										</span>
									</button>
								</>}
							</div>
						</div>
					</div>
				</div>

				<div className="promo-fields-group">
					<div className="promo-fields promo-action-fields">
						<div className="promo-field info">
							{/*<p>*{t("Required fields")}</p>*/}
						</div>
						<div className="promo-field action">
							<div>
								<a href={window.promotionHome}
								   className="btn btn-primary-text link">
									{t("Go Back")}
								</a>
								<button type="button"
										disabled={true}
										className="btn btn-primary"
										onClick={handleNextStep}>
									<span className="in-btn-text">
										{t("Continue")}
									</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
